import React from "react";
import { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Loader from "../../common/loader";
import { Button } from 'react-bootstrap';
import {TabContent,TabPane,Nav,NavItem,NavLink,Modal,ModalBody,ModalFooter,ModalHeader} from "reactstrap";
import httpService from "../../../services/http.service";
import "bootstrap/dist/css/bootstrap.min.css";
import ErrorMessage from "../../common/errorMsg";
import SuccessMessage from "../../common/successMsg";
import Navbar from './settingNav';
import WarningMessage from "../../common/warnMsg";

const SingleUserBackup = (props) => {

    const [singleUserLocalBackups, setSingleUserLocalBackups] = useState([]);
    const [formdata, setFormData] = useState({});
    const [uploaded, setUploaded] = useState(false);
    const [isloading, setLoading] = useState(false);
    const [modallocal, setModalLocal] = useState(null);
    const [uploadModal, setUploadModal] = useState(false);
    // const [err, setErr] = useState(false);
    const [modaleditLayoutPropPass, setmodaleditLayoutPropPass] = useState(false);
    const [replicateUser, setReplicateUser] = useState('');
    const [restoreFile, setRestoreFile] = useState('')

    const GetSingleUserBackup = async () => {
        let res = await httpService.get("GetSingleUserBackup")
            .then((res) => {
                let result = res.data
                setSingleUserLocalBackups(result);
            })
            .catch((err) => {
                if (err && err.response && err.response.status == 401) {
                  ErrorMessage("Session expired, please login again")
                }
                return
              });
    }
    useEffect(async () => {
        GetSingleUserBackup();
    }, [uploaded]);

    const ProceedToTakeBackup = async () => {
        if(replicateUser==""){
            WarningMessage("Please select  user !")
            return;
        }
        let userID = replicateUser.split('+')[0], userNameWithWhiteSpace = replicateUser.split('+')[1];
        let userName = userNameWithWhiteSpace.replaceAll(' ', '');
        if (!userID || !userName) {
            ErrorMessage('Please select user !')
            return;
        }
        let data = {
            userName: userName,
            userID: userID
        }
        try {
            let res = await httpService.getByBoj(`createSingleUserBackup`, data)
            if (res) {
                if (res.data.ack == '1') {
                    console.log('Now you will get single user backup list')
                    await GetSingleUserBackup();
                    SuccessMessage("Backup created successfully")
                }
            }
            else {
                ErrorMessage('Something went wrong')
            }
        }
        catch (err) {
            ErrorMessage('Something went wrong')
        }
        setReplicateUser("")
        setmodaleditLayoutPropPass(false);
    }

    const toggleeditLayoutPropPass = (name) => {
        // if (!modaleditLayoutPropPass) {
        // }
        setmodaleditLayoutPropPass((prevState) => !prevState)
    }

    const toggleUploadModal = () => {
        setUploadModal(!uploadModal);
    };

    const restoreHandler = async () => {
        setLoading(true);
        if (!restoreFile) {
            ErrorMessage('File not selected !!')
            return;
        }
        let data = {
            user: localStorage.getItem("Username"),
            foldername: restoreFile,
        };
        let res = await httpService.getByBoj("restoreLocalForSingleUser", data)
        if (res) {
            setLoading(false);
            if (res.data.ack === "1") {
                await props.getAllPropertyData();
                SuccessMessage("Databse Restored successfully");
            }
            else {
                ErrorMessage("Databse could not be restored")
            }
        }
    };

    const uploadbackupForSingleCustomer = async (e) => {
        e.preventDefault();
        toggleUploadModal();
        let data = {
            file: formdata,
            user: localStorage.getItem("Username")
        };
        setLoading(true);
        let res = await httpService
            .uploadbackupForSingleCustomer("uploadbackupForSingleCustomer", data)
            .then((res) => res.data)
            .catch((err) => {
                setLoading(false);
            });
        if (res) {
            setLoading(false);
            if (res.ack === "1") {
                SuccessMessage(res.msg)
            }
            if (res.ack === "0") {
                ErrorMessage(res.msg)
            }
        }
        setUploaded(!uploaded);
        return;
    };

    const downloadHandler = async (folderName, downloadName) => {
        let data = {
            folderName: folderName,
            downloadName: downloadName
        }
        let res = await httpService.getBackup("downloadSingleUserBackup/" + folderName)
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${downloadName}.zip`);
                document.body.appendChild(link);
                link.click();
                SuccessMessage(res.msg);
            })
            .catch((err) => {
                setLoading(false);
                ErrorMessage(res.err)
            });
        }
    return (
        <div style={{ margin: "15px" }}>
            <Navbar activeTab={'GetRecordOfSingleUser'} />
            {isloading ? <Loader /> : ''}
            <div className="pad-15 mt-5">
                <div className="form-boxdiv">
                    <div className="card-body">
                        <Nav tabs className="backup-tabs mb-3">
                            <NavItem>
                                <NavLink className='take-backup btn-primary text-white py-2'
                                    onClick={() => {
                                        setmodaleditLayoutPropPass(true)
                                    }}>
                                    Take Customer's Backup
                                </NavLink>
                            </NavItem>
                            <div className="" style={{ alignItems: "flex-end" }}>
                                <button
                                    className="btn btn-md btn-primary py-2"
                                    style={{ display: "inline-block" }}
                                    onClick={toggleUploadModal}
                                >
                                    Upload Backup
                                </button>
                            </div>
                        </Nav>
                        <TabContent activeTab={'local'}>
                            <TabPane tabId="local">
                                <table className="table table-bordered backup-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">S.No.</th>
                                            <th scope="col" colSpan="2">
                                                Customer Backups
                                            </th>
                                            <th scope="col">
                                                <span style={{ float: "right", paddingRight: "4rem" }}>
                                                    Actions
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {singleUserLocalBackups.length
                                            ? singleUserLocalBackups.slice(0).reverse().map((p, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td colSpan="2">{p}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger"
                                                                style={{ float: "right", marginLeft: "10px" }}
                                                                onClick={() => {
                                                                    setModalLocal(!modallocal)
                                                                    setRestoreFile(p)
                                                                }
                                                                }
                                                            >
                                                                Restore
                                                            </button>
                                                            <Modal
                                                                id={p}
                                                                isOpen={modallocal}
                                                                className="file-del-popup"
                                                            >
                                                                <ModalHeader>Database Restore</ModalHeader>
                                                                <ModalBody className="font-size-16">
                                                                    Are you sure you want to Restore the
                                                                    database, this action is irreversible.
                                                                </ModalBody>
                                                                <ModalFooter>
                                                                    <button
                                                                        className="btn btn-success"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            restoreHandler();
                                                                            setModalLocal(!modallocal);
                                                                        }}
                                                                    >
                                                                        Yes
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-danger"
                                                                        onClick={() => {
                                                                            setModalLocal(!modallocal);
                                                                        }}
                                                                    >
                                                                        No
                                                                    </button>
                                                                </ModalFooter>
                                                            </Modal>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-info"
                                                                style={{ float: "right" }}
                                                                onClick={() =>
                                                                    downloadHandler(
                                                                        p, p
                                                                    )
                                                                }
                                                            >
                                                                Download
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            : <></>}
                                    </tbody>
                                </table>
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
            </div>
            <Modal size="md" isOpen={modaleditLayoutPropPass} toggle={() => toggleeditLayoutPropPass("")}>
                <ModalHeader toggle={() => toggleeditLayoutPropPass("")}>Select Customer For Backup</ModalHeader>
                <ModalBody>
                    <div>
                        <label style={{ marginTop: "0px" }}>
                            <b>Select the customer to take bakup </b>
                            <b style={{ color: "red" }}>*</b>
                        </label>
                        <select
                            className="form-control mt-3"
                            value={replicateUser}
                            name='replicateUser'
                            onChange={(e) => {
                                setReplicateUser(e.target.value)
                            }}
                        >
                            <option value=''>Select Customer</option>
                            {props.allData.users && props.allData.users.map((e) =>
                                e.type !== 'admin' && <option value={e._id + '+' + e.customerId}>{e.customerId}</option>
                            )}
                        </select>
                        <div className="row">
                            <Button
                                color="primary"
                                onClick={() =>
                                    ProceedToTakeBackup()
                                }
                                className="ButtonProceed"
                            >
                                Proceed
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={uploadModal} toggle={toggleUploadModal}>
                <ModalHeader toggle={toggleUploadModal}>Upload Backup</ModalHeader>
                <ModalBody>
                    <form
                        onSubmit={(e) => {
                            uploadbackupForSingleCustomer(e);
                        }}
                    >
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label className="form-check-label">File :</label>
                                    <input
                                        className="form-control"
                                        type="file"
                                        required={true}
                                        id="formFile"
                                        accept=".zip,.rar,.7zip"
                                        onChange={(event) => {
                                            if (!event.target.files[0]) return { ack: "0", msg: "Please select a file" }
                                            setFormData(event.target.files[0]);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-danger marb-15"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleUploadModal();
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-success marl-15 marb-15"
                                type="submit"
                            >
                                Upload
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default SingleUserBackup;
